import { createReducer } from 'typesafe-actions';
import actions, { OcrMapsAction } from './actions';
import { OcrMapsState } from './types';

export const initState = {
  maps: [],
  isFetching: false,
  hasFetched: false,
};

const reducer = createReducer<OcrMapsState, OcrMapsAction>(initState)
  .handleAction(actions.fetch.request, (state) => ({
    ...state,
    isFetching: true,
  }))
  .handleAction(actions.fetch.failure, (state) => ({
    ...state,
    isFetching: false,
  }))
  .handleAction(actions.fetch.success, (state, { payload }) => ({
    isFetching: false,
    hasFetched: true,
    maps: payload,
  }))
  .handleAction(actions.create.success, (state, { meta }) => {
    const maps = [...state.maps, meta];
    return {
      ...state,
      maps,
    };
  })
  .handleAction(actions.patch.success, (state, { payload }) => {
    const index = state.maps.findIndex((item) => item.id === payload.id);

    return {
      ...state,
      maps: [
        ...state.maps.slice(0, index),
        payload,
        ...state.maps.slice(index + 1),
      ],
    };
  });

export default reducer;
